import { render, staticRenderFns } from "./VisitDetail.vue?vue&type=template&id=2642c35a&scoped=true"
import script from "./VisitDetail.vue?vue&type=script&lang=js"
export * from "./VisitDetail.vue?vue&type=script&lang=js"
import style0 from "./VisitDetail.vue?vue&type=style&index=0&id=2642c35a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2642c35a",
  null
  
)

export default component.exports